import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { DateCustomFormatPipe } from '../pipes/date-custom.pipe';
import {
  MinutesPastMidnightToMeridiemPipe,
  MinutesPastMidnightToTwelveHourPipe,
  MinutesPastMidnightToTwentyFourHourPipe,
} from '../pipes/dates/time-conversion-pipes';
import { DisplayFullNamePipe } from '../pipes/display-full-name.pipe';
import { FilterByRocksTeamIdPipe } from '../pipes/filter-by-rocks-team-id.pipe';
import { FilterByTeamIdPipe } from '../pipes/filter-by-team-id.pipe';
import { FilterMilestonesPipe } from '../pipes/filter-milestones.pipe';
import { FilterOutItemByIdPipe } from '../pipes/filter-out-item-by-id.pipe';
import { FilterOutProjectTeamsPipe } from '../pipes/filter-out-project-teams.pipe';
import { FilterOutTeamPipe } from '../pipes/filter-out-team.pipe';
import { FilterOutUsedDefaultSectionsPipe } from '../pipes/filter-out-used-default-sections.pipe';
import { FilterReducerPipe } from '../pipes/filter-reducer/filter-reducer.pipe';
import { JoinPropertiesPipe } from '../pipes/join-properties/join-properties.pipe';
import { OrderAlphabeticallyPipe } from '../pipes/order-alphabetically.pipe';
import { OrderByTitlePipe } from '../pipes/order-by-title/order-by-title.pipe';
import { OrderByPipe } from '../pipes/order-by.pipe';
import { SearchFilterPipe } from '../pipes/search-filter.pipe';
import { SortByCompanyNamePipe } from '../pipes/sort-by-company-name.pipe';
import { SortByNamePipe } from '../pipes/sort-by-name/sort-by-name.pipe';
import { SortByUserNamePipe } from '../pipes/sort-by-user-name.pipe';
import { UnitNamePipe } from '../pipes/unit-name/unit-name.pipe';
import { UserInitialsPipe } from '../pipes/user-initials/user-initials.pipe';

import { FroalaOptions } from './components/text-editor/froala-options';
import { FroalaTextEditorOptions } from './components/text-editor/froala-text-editor-options';
import { TextEditorOptions } from './components/text-editor/text-editor-options';

@NgModule({
  providers: [
    OrderByPipe,
    SearchFilterPipe,
    SortByUserNamePipe,
    CurrencyPipe,
    DecimalPipe,
    OrderByTitlePipe,
    FilterOutProjectTeamsPipe,
    FilterOutTeamPipe,
    FilterByTeamIdPipe,
    FilterMilestonesPipe,
    FilterByRocksTeamIdPipe,
    OrderAlphabeticallyPipe,
    SortByNamePipe,
    MinutesPastMidnightToTwelveHourPipe,
    MinutesPastMidnightToTwentyFourHourPipe,
    MinutesPastMidnightToMeridiemPipe,
    FilterOutItemByIdPipe,
    SortByCompanyNamePipe,
    JoinPropertiesPipe,
    FilterOutUsedDefaultSectionsPipe,
    FilterReducerPipe,
    UnitNamePipe,
    DisplayFullNamePipe,
    UserInitialsPipe,
    DateCustomFormatPipe,
    PercentPipe,
    {
      provide: TextEditorOptions,
      useFactory: () => new TextEditorOptions<FroalaOptions>(new FroalaTextEditorOptions()),
    },
    {
      provide: FroalaTextEditorOptions,
      useFactory: () => new FroalaTextEditorOptions(),
    },
  ],
})
export class SharedModule {}
